export default __webpack_public_path__ + "static/media/support-notes-main-bloomberg.1b9d0ab7.png";